export default {
  sectionTitle: 'Claim Flags Configuration',
  sectionDescription: 'Define and manage the flags adjusters can apply to claims, and scope each to sub-orgs and LoBs.',
  emptyStateTitle: 'No claim flags yet',
  emptyStateDescription: 'Start by adding the first flag adjusters can apply to claims.',
  createFlag: 'Create Flag',
  addFlag: 'Add Flag',
  editFlag: 'Edit Flag',
  required: 'Required',
  keyMustBeUnique: 'Key must be unique',
  keyMustMatchPattern: 'Key may only contain lowercase letters, numbers and underscores',
  keyMustContainLetterOrNumber: 'Key must contain at least one letter or number',
  cancel: 'Cancel',
  save: 'Save',
  narrowedScope: {
    title: 'Existing claims keep this flag',
    removedSubOrgs: 'Sub-organizations removed from the scope:',
    removedLobs: 'Lines of business removed from the scope:',
    explanation:
      'Claims that already have this flag keep it, including claims in the scope you removed — they still show the flag and are still returned when you filter claims by it. From now on the flag can only be applied to claims inside the new scope.',
    confirm: 'Save Anyway',
    keepEditing: 'Keep Editing',
  },
  labels: {
    label: 'Label',
    key: 'Key',
    color: 'Color',
  },
  columns: {
    color: 'Color',
    key: 'Key',
    label: 'Label',
    subOrgs: 'Sub Orgs',
    lobs: 'Lines of Business',
    enabled: 'Enabled',
    actions: 'Actions',
  },
} as const;
